import { render, staticRenderFns } from "./welcomeDemoPopup.vue?vue&type=template&id=401b6e3a"
import script from "./welcomeDemoPopup.vue?vue&type=script&lang=js"
export * from "./welcomeDemoPopup.vue?vue&type=script&lang=js"
import style0 from "./welcomeDemoPopup.vue?vue&type=style&index=0&id=401b6e3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports